import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import { merge, concat, filter, forEach, valuesIn } from 'lodash';

import * as jobRequestApi from '../../../../redux/actionCreators/async/jobrequests';
import * as jobRequestStore from '../../../../redux/actionCreators/sync/jobrequests';
import * as asyncActionCreator from '../../../../redux/actionCreators/async';
import * as adminStore from '../../../../redux/actionCreators/sync/index';

import JobRequestTable from '../../../../common/components/JobRequestTable';

@connect((store, props) => ({
	user: store.user,
	jobRequests: store.jobRequests,
  filters: store.admin.jobRequests.filters,
  searchTerms: store.admin.jobRequests.searchTerms,
	contacts: store.admin.contacts,
	companies: store.admin.companies,
	staticData: store.staticData,
  labels: store.labels.JobRequestDashboard,
	route: {
		params: props.params,
		query: props.location.query
	} // actually being from from react-redux-router to regular props
}))
export default class JobRequestDashboard extends Component {
	static propTypes = {
		dispatch : PropTypes.func.isRequired,
		user: PropTypes.object,
		jobRequests: PropTypes.object,
		staticData: PropTypes.object,
    contacts: PropTypes.object,
    filters: PropTypes.object,
    searchTerms: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
    labels: PropTypes.object,
	}


	constructor(props, context) {
		super(props, context);

		this.state = {
			jobRequests: [],
			filterApplied: false,
			filterRules: {},
			searchQuery: null
		};

	}

	componentWillMount() {
		// load contacts in case they're not in yet
    if (!this.props.contacts.items || this.props.contacts.items.length <= 0) {
      this.props.dispatch(asyncActionCreator.searchContacts([]));
    }

		if (Object.keys(this.props.companies).length <= 1) {
			this.props.dispatch(asyncActionCreator.searchCompanies([]));
		}
	}

	componentWillReceiveProps(nextProps) {
		if(nextProps.jobRequests) {
			if(this.state.filterApplied) {
				this.setState({jobRequests: filter(nextProps.jobRequests, this.state.filterRules), filterApplied: true});
			}else{
				this.setState(merge({}, this.state, {jobRequests: nextProps.jobRequests}));
			}
		}
		if(nextProps.route.query.search !== this.props.route.query.search) {
			this.setState(merge({}, this.state, {searchQuery: nextProps.route.query.search}));
		}
	}


	loadAll(set) {
    let allData = [];

    forEach(set, (section) => {
      allData = concat(allData, section);
    });

    return allData;
  }

  onJobRequestFilterChange(filters = {}) {
    this.props.dispatch(adminStore.updateJobRequestFilters(filters));
  }

  onJobRequestTermsChange(terms = []) {
    this.props.dispatch(adminStore.updateJobRequestTerms(terms));
  }

  fetchJobRequests(filters = {}, terms = [], skip) {
    const callbacks = {
      success: (items) => this.props.dispatch(jobRequestStore.updateJobRequests(items)),
      error: (err) => console.error('getAllJobs failed', err),
    };

    this.props.dispatch(jobRequestApi.getAllJobs(
      callbacks,
      skip,
      terms,
      filters,
    ));
  }

	render() {
		return (
			<div className='job-request-dashboard content-container'>
					<JobRequestTable
						jobRequestsList={valuesIn(this.props.jobRequests)}
            onJobRequestFilterChange={::this.onJobRequestFilterChange}
            onJobRequestTermsChange={::this.onJobRequestTermsChange}
            fetchJobs={::this.fetchJobRequests}
            location={this.props.location.pathname}
						companies={this.loadAll(this.props.companies)}
						contacts={this.props.contacts.items}
            filters={this.props.filters || {}}
            searchTerms={this.props.searchTerms || []}
            columns={['Id', 'DateCreated', 'DateSubmitted', 'Title', 'Status', 'Contact', 'Company', 'Firm', 'Industry']}
            labels={this.props.labels.jobRequestTable}
          />
		</div>
		);
	}
}



// WEBPACK FOOTER //
// ./shared/react/admin/JobRequest/Dashboard/index.js